exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  width: 100%;\n}\n.main {\n  margin: 0;\n  padding: 0;\n  background-color: #fafafa;\n}\n.main__container {\n  display: flex;\n  min-height: 92vh;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/Main/containers/Main.less
// module id = 1429
// module chunks = 0